module.exports = __webpack_public_path__ + "img/electronic_pending_zone_selected.05d92547.svg";